import { Paper, Table, TableBody, TableCell, TableContainer, Box, Typography, RadioGroup, FormControlLabel, Radio, TextField, Button, Stack, Chip, TableHead, TableRow, TablePagination } from "@mui/material";
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";

const RecallPgaes = () => {
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState("page");
    const [message, setMessage] = useState("");
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const navigate = useNavigate();

    const fetchList = async () => {
        try {
            setLoading(true);
            const response = await ApiService.get('/general-recall/list');

            if (response.status === 200) {
                setListData(response.data);
            }
        } catch (error) {
            console.log("List Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleSubmit = async () => {
        if (!message.trim()) return;

        const payload = {
            page_type: type === "page" ? "Page" : "Recall",
            page_text: message,
        };

        try {
            const res = await ApiService.post("/general-recall/create", payload);

            if (res.status) {
                toast.success(res.message || "Created successfully");
                const created = res.data;
                fetchList(false);
                setMessage("");
                console.log("page_type=====>71", type)
                if (type === "recall") {
                    navigate(`/firehouse/general-recall/${created.Shift_Date}/${created.shift_number}`)
                }
            }
        } catch (error) {
            toast.error(error?.data?.message);
        }
    };

    const handleSaveClose = async () => {
        if (!selectedRow) return;

        const payload = {
            Shift_Date: selectedRow.shift_date,
            Shift_Number: selectedRow.shift_number,
        };

        try {
            const res = await ApiService.post("/general-recall/close", payload);
            toast.success("Closed successfully");
            setOpenPopup(false);
            fetchList();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    // const formatFullDateTime = (dateString) => {
    //   if (!dateString) return "";

    //   const date = new Date(dateString);

    //   const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    //   const monthNames = [
    //     "January", "February", "March", "April", "May", "June",
    //     "July", "August", "September", "October", "November", "December"
    //   ];

    //   const day = date.getDate();
    //   const daySuffix =
    //     day % 10 === 1 && day !== 11 ? "st" :
    //     day % 10 === 2 && day !== 12 ? "nd" :
    //     day % 10 === 3 && day !== 13 ? "rd" : "th";

    //   const dayName = dayNames[date.getDay()];
    //   const monthName = monthNames[date.getMonth()];
    //   const year = date.getFullYear();

    //   const hh = String(date.getHours()).padStart(2, "0");
    //   const mm = String(date.getMinutes()).padStart(2, "0");
    //   const ss = String(date.getSeconds()).padStart(2, "0");

    //   return `${dayName} ${day}${daySuffix} ${monthName} ${hh}:${mm}:${ss}`;
    // };

    const formatDateWithMoment = (dateString) => {
        if (!dateString) return "";
        return moment(dateString).format("MM/DD/YYYY ddd hh:mm A");
    };
    return (
        <>
            <Paper className="p-3" style={{ marginTop: "1rem" }}>
                <Box sx={{ p: 3 }}>
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        General Recall/Page
                    </Typography>

                    <RadioGroup
                        row
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                        sx={{ mb: 2 }}
                    >
                        <FormControlLabel value="recall" control={<Radio />} label="General Recall"
                            disabled={listData?.active_call === true} />
                        <FormControlLabel value="page" control={<Radio />} label="Page" />
                    </RadioGroup>

                    <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        placeholder="Enter message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        sx={{ mb: 2 }}
                    />

                    <Button variant="contained" onClick={handleSubmit}>
                        {type === "page" ? "Page" : "Recall"}
                    </Button>

                    <Box sx={{ my: 3, borderBottom: "1px solid #ccc" }} />

                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Recent Recalls/Pages
                    </Typography>

                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Created by</TableCell>
                                    <TableCell>Type & Message</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {loading && (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                                            <CircularProgress />
                                        </TableCell>
                                    </TableRow>
                                )}


                                {!loading &&
                                    listData?.data?.map((r) => (
                                        <TableRow key={r.id}>
                                            <TableCell>{formatDateWithMoment(r.log_time)}</TableCell>

                                            <TableCell>
                                                <Chip
                                                    label={r.status_text || "N/A"}
                                                    sx={{
                                                        color: r.status_text === "ACTIVE" ? "green" : "black",
                                                        backgroundColor: r.status_text === "ACTIVE" ? "#B0DB9C" : "#E0E0E0",
                                                        fontWeight: "bold",
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                {r.created_by}
                                            </TableCell>

                                            <TableCell>
                                                {r.log_text}
                                            </TableCell>

                                            <TableCell>
                                                {r.status_text === "ACTIVE" && (
                                                    <Stack direction="row" spacing={1}>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() => navigate(`/firehouse/general-recall/${r.shift_date}/${r.shift_number}`)}
                                                        >
                                                            View
                                                        </Button>

                                                        {/* {r.status_text === "ACTIVE" && ( */}
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="error"
                                                            onClick={() => {
                                                                setSelectedRow(r);
                                                                setOpenPopup(true);
                                                            }}
                                                        >
                                                            Close
                                                        </Button>

                                                        {/* )} */}
                                                    </Stack>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                {/* No data */}
                                {!loading && listData.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            No data found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Paper>

            <Modal show={openPopup} onHide={() => { setOpenPopup(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Close General Recall</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        <>
                            <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                {selectedRow?.log_date}
                            </Typography>

                            <Typography sx={{ fontSize: "14px", mt: 1 }}>
                                <strong>
                                    {formatDateWithMoment(selectedRow?.log_time)}
                                </strong>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                {selectedRow?.log_text}
                            </Typography>
                        </>
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setOpenPopup(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleSaveClose}>
                                Save
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default RecallPgaes;
